let ranges = {
  taser: [ 0, 5, 10, 15, 20 ],
  holdout: [ 0, 5, 15, 30, 50 ],
  lPistol: [ 0, 5, 15, 30, 50 ],
  hPistol: [ 0, 5, 20, 40, 60 ],
  mPistol: [ 0, 5, 15, 30, 50 ],
  smg: [ 0, 10, 40, 80, 150 ],
  ar: [ 0, 25, 150, 350, 550 ],
  fShotgun: [ 0, 15, 30, 45, 60 ],
  sShotgun: [ 0, 10, 40, 80, 150 ],
  sniper: [ 0, 50, 350, 800, 1500 ],
  lmg: [ 0, 25, 200, 400, 800 ],
  hmg: [ 0, 40, 250, 750, 1200 ],
  cannon: [ 0, 50, 300, 750, 1500 ],
  gLaunch: [ 5, 50, 100, 150, 500 ],
  mLaunch: [ 20, 70, 150, 450, 1500 ],
  bow: [ 0, 1, 10, 30, 60 ],
  lCross: [ 0, 6, 24, 60, 120 ],
  mCross: [ 0, 9, 36, 90, 150 ],
  hCross: [ 0, 15, 45, 120, 180 ],
  knife: [ 0, 1, 2, 3, 5 ],
  shuriken: [ 0, 1, 2, 5, 7 ],
  sGrenade: [ 0, 2, 4, 6, 10 ],
  aGrenade: [ 0, 2, 4, 8, 15 ]
}

let strengthWeapons = [ 'bow', 'knife', 'shuriken', 'sGrenade', 'aGrenade' ]
let noRecoilWeapons = [ 'bow', 'lCross', 'mCross', 'hCross', 'knife', 'shuriken', 'sGrenade', 'aGrenade' ]

export default {
  isStrengthWeapon: function (weaponType) {
    return strengthWeapons.indexOf(weaponType) !== -1
  },

  hasRecoil: function (weaponType) {
    return noRecoilWeapons.indexOf(weaponType) === -1
  },

  getRange: function (weaponType, strength) {
    let baseRange = ranges[weaponType]

    if (this.isStrengthWeapon(weaponType)) {
      return baseRange.map(elem => elem * strength)
    }

    return baseRange
  }
}



// WEBPACK FOOTER //
// ./src/data/weaponData.js